import { NextIntlClientProvider } from 'next-intl'
import { ReactElement, useContext } from 'react'
import { merge } from 'lodash'
import { RU } from '../../../../langs/ru'
import { UZ } from '../../../../langs/uz'
import { KZ } from '../../../../langs/kz'
import { Languages } from '../../../../interfaces/common'
import { LanguageContext } from '../../../LanguageContext/LanguageContext'

const messages = {
  [Languages.RU]: RU,
  [Languages.KZ]: merge({}, RU, KZ),
  [Languages.UZ]: merge({}, RU, UZ),
}

type NextIntlProviderProps = {
  children: ReactElement
}

export const NextIntlProvider = ({ children }: NextIntlProviderProps) => {
  const { language } = useContext(LanguageContext)

  return (
    <NextIntlClientProvider locale={Languages.RU} messages={messages[language]} timeZone="Europe/Moscow">
      {children}
    </NextIntlClientProvider>
  )
}
